import {
  Box,
  Button,
  Container,
  Divider,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import Meta from "../Meta/Meta";
import content from "./privacyPolicyContent";

const PrivacyPolicyPage = () => {
  const { i18n } = useTranslation();
  const language = i18n.language?.split("-")[0];
  const current = content[language] || content.en;
  const dir = language === "ar" ? "rtl" : "ltr";

  const openCookieSettings = () => {
    window.dispatchEvent(new Event("openCookieSettings"));
  };

  return (
    <>
      <Meta
        title={`${current.title} | ALGermanist`}
        description={current.intro}
        keywords="privacy policy, cookie settings, datenschutz, cookies, ALGermanist"
      />
      <Box sx={{ bgcolor: "#F7F9FA", py: { xs: 5, md: 8 }, direction: dir }}>
        <Container maxWidth="lg">
          <Stack spacing={3} sx={{ mb: 4 }}>
            <Typography
              variant="overline"
              sx={{ color: "#6B7280", fontWeight: 700, letterSpacing: 0 }}
            >
              {current.langLabel}
            </Typography>
            <Typography
              variant="h1"
              sx={{
                fontSize: { xs: "2.2rem", md: "3.6rem" },
                fontWeight: 900,
                lineHeight: 1.08,
                color: "#101828",
              }}
            >
              {current.title}
            </Typography>
            <Typography
              sx={{
                maxWidth: 850,
                color: "#475467",
                fontSize: { xs: "1rem", md: "1.12rem" },
                lineHeight: 1.8,
              }}
            >
              {current.intro}
            </Typography>
            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={1.5}
              alignItems={{ xs: "stretch", sm: "center" }}
            >
              <Button
                variant="contained"
                onClick={openCookieSettings}
                sx={{
                  bgcolor: "#F2C200",
                  color: "#111",
                  fontWeight: 800,
                  borderRadius: 2,
                  textTransform: "none",
                  "&:hover": { bgcolor: "#E0B400" },
                }}
              >
                {language === "de"
                  ? "Cookie-Einstellungen öffnen"
                  : language === "ar"
                  ? "فتح إعدادات ملفات الارتباط"
                  : "Open Cookie Settings"}
              </Button>
              <Typography sx={{ color: "#667085", fontSize: "0.95rem" }}>
                {current.updated}
              </Typography>
            </Stack>
          </Stack>

          <Paper
            elevation={0}
            sx={{
              border: "1px solid #E4E7EC",
              borderRadius: 2,
              overflow: "hidden",
              bgcolor: "#fff",
            }}
          >
            <Box sx={{ p: { xs: 2.5, md: 4 } }}>
              <Typography
                variant="h2"
                sx={{ fontSize: { xs: "1.55rem", md: "2rem" }, fontWeight: 850 }}
              >
                {current.subtitle}
              </Typography>
            </Box>
            <Divider />
            <Stack divider={<Divider />} sx={{ p: { xs: 2.5, md: 4 }, pt: 0 }}>
              {current.sections.map((section) => (
                <Box key={section.title} sx={{ py: { xs: 2.25, md: 3 } }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { xs: "1.1rem", md: "1.25rem" },
                      fontWeight: 850,
                      mb: 1.5,
                      color: "#101828",
                    }}
                  >
                    {section.title}
                  </Typography>
                  <Stack spacing={1.1}>
                    {section.body.map((paragraph) => (
                      <Typography
                        key={paragraph}
                        sx={{
                          color: "#344054",
                          lineHeight: 1.75,
                          fontSize: { xs: "0.96rem", md: "1rem" },
                          whiteSpace: "pre-line",
                        }}
                      >
                        {paragraph}
                      </Typography>
                    ))}
                  </Stack>
                </Box>
              ))}
            </Stack>
          </Paper>
        </Container>
      </Box>
    </>
  );
};

export default PrivacyPolicyPage;
